import React from 'react'

const Certification = () => {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-center text-gray-800 mb-6">
                🎓 Certifications
              </h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {/* Certificate Card 1 */}
                <div className="bg-slate-100 rounded-xl p-5 shadow-md hover:shadow-lg transition duration-300">
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">
                    Oracle Generative AI Certified Professional
                  </h3>
                  <p className="text-sm text-gray-600">
                    Credentialed by Oracle, showcasing proficiency in Generative
                    AI principles and real-world applications.
                  </p>
                </div>

                {/* Certificate Card 2 */}
                <div className="bg-slate-100 rounded-xl p-5 shadow-md hover:shadow-lg transition duration-300">
                  <h3 className="text-lg font-semibold text-gray-700 mb-2">
                    Salesforce Certified AI Associate
                  </h3>
                  <p className="text-sm text-gray-600">
                    Recognized by Salesforce for foundational understanding of
                    AI capabilities within Salesforce ecosystem.
                  </p>
                </div>
              </div>
    </div>
  )
}

export default Certification
